import { PredefinedMessageModel } from "../schema/predefined-message.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class PredefinedMessageContainer extends MongoBaseContainer{
    predefined_message: PredefinedMessageModel
}
